import React from 'react';

const AsyncAuthorList = React.lazy(() => import('./ListContainer'));

export const AuthorList = () => {
  return <AsyncAuthorList />;
};
